
















import { Component, Vue, Watch } from "vue-property-decorator";
@Component
export default class Logout extends Vue {
  public showModel = false;
  public leave: any = "";
  @Watch("showModel")
  public isChange(val) {
    if (val) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  }
  public show(val) {
    this.leave = val;
    this.showModel = true;
  }
  public prev(val) {
    this.showModel = false;
    if (!val) {
      this.$emit("showModel", true);
      this.$router.push(this.leave.path);
    }
  }
}
